"use client" 
import { useEffect, useState, useRef, use, Fragment } from "react";
import axios from "axios";

import { useParams } from "next/navigation";
import { humanizeString, standardizeFileName } from "@/utils/frontend/stringOps.js";
import ModalOverlay from "../../Atoms/ModalOverlay.js";
import ModalHeader from "./ModalHeader.js";
import ModalFooter from "./ModalFooter.js";
import RadioButton from "../../Atoms/Buttons/RadioButton.js";
import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
import LocationSelect from "../../Atoms/Select/LocationSelect.js";
import { getCookies } from "@/utils/frontend/cookieOps.js";
import InputText from "@/components/Atoms/inputText.js";
import TextEditor from "../TextEditor.js";
import TagsAssociationSelect from "@/components/Atoms/Select/TagsAssociationSelect.js";
import DatePicker from "@/components/Atoms/FormElements/DatePicker.js";
import SectorSelect from "@/components/Atoms/Select/SectorSelect.js";
import { getData } from "@/utils/frontend/dataOps.js";
import { dateFormat_0 } from "@/utils/frontend/dateOps.js";
import MarkdownEditor from "../MarkdownEditor.js";
import JobPreviewCard from "../Cards/JobPreviewCard.js";
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod.js";
import ReactMarkdown from 'react-markdown'
import { validateRequiredFieldsManually } from "@/utils/frontend/validateRequiredFieldsManually.js";
import TalentPreviewCard from "../Cards/TalentPreviewCard.js";
import urlBuilder from "@/utils/backend/urlBuilder.js";
import DivisionSelect from "@/components/Atoms/Select/DivisionSelect.js";
import { MinusButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons.js";
import ReactMarkdownMod_2 from "@/components/Atoms/ReactMarkdownMod_2.js";
import LocationSelectGeoNames from "@/components/Atoms/Select/LocationSelectGeoNames.js";
import CurrencySelect from "@/components/Atoms/Select/CurrencySelect.js";
import FileUploadDragAndDrop from "@/components/Atoms/FileUploadDragAndDrop.js";

const TalentModal =  ({
  // userPrivateTalentsCount,
  user,
  state,
  callback,
  target,
  organizationPreferences,
  modalHeaderCaption
}) => {

  // console.log("USER@TALENTMODAL", user)
  const lang = 'en'
  const textAreaRef1 = useRef(null);
  const textAreaRef2 = useRef(null);
  // console.log("userPrivateTalentsCount", userPrivateTalentsCount)
  // console.log("TARGET@TalentModal", target)

  // const user = getCookies().user
  
  // get current Primary and Secondary tag associations and set them as default values for 
  let targetAssociatedLevel1Tags = [] // later set as State
  let targetAssociatedLevel2Tags = [] // later set as State
  let targetAssociatedLevel3Tags = [] // later set as State
  // if (target && target.tags) { 
  //   target.tags.filter(tag => {tag.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : targetAssociatedLevel2Tags.push(tag)})
  // }

  if (target && target.tags) { 
    target.tags.filter(tag => {tag.tag_snapshot.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : tag.tag_snapshot.tag_level === 2 ? targetAssociatedLevel2Tags.push(tag) : targetAssociatedLevel3Tags.push(tag)})
  }



  const blankDataInit = {
    id: 0,
    talent_full_name: '',
    talent_pseudonym: '',
    talent_job_title_en: '',
    talent_job_title_fr: '',
    talent_resume_en: '',
    talent_resume_fr: '',
    talent_salary: '',
    talent_salary_currency: '',
    talent_salary_period: '',
    // talent_location: user?.user_location || '',
    // talent_location_country: user?.user_location.country || '',
    // talent_location_state: user?.user_location.state || '',
    // talent_location_city: user?.user_location.city || '',
    // talent_location: user.user_location ? user.user_location : null,
    talent_location: user?.user_location || null,
    talent_status: "PENDING_REVIEW",
    talent_access_level: "STANDARD",
    // talent_profile_passwords: {1: {contact_name: '', contact_password: ''}},
    talent_profile_passwords: [{"contact_name": "INIT", "contact_password": ""}],
    talent_profile_password_expiration_date: dateFormat_0(new Date().setUTCDate(new Date().getUTCDate() + 7)),
    talent_is_published: "PUBLISHED" ,
    talent_sector_industry: ''
  }

  const targetDataInit = {
    id: target?.id,
    talent_full_name: target?.talent_full_name,
    talent_pseudonym: target?.talent_pseudonym,
    talent_job_title_en: target?.talent_job_title.en,
    talent_job_title_fr: target?.talent_job_title.fr,
    talent_resume_en: target?.talent_resume.en,
    talent_resume_fr: target?.talent_resume.fr,
    talent_salary: target?.talent_conditions?.talent_salary,
    talent_salary_currency: target?.talent_conditions?.talent_salary_currency,
    talent_salary_period:  target?.talent_conditions?.talent_salary_period,
    // talent_location_country: target?.talent_location.country || user?.user_location.country,
    // talent_location_state: target?.talent_location.state || user?.user_location.state,
    // talent_location_city: target?.talent_location.city || user?.user_location.city,
    talent_location: target?.talent_location || user.user_location,
    talent_status: target?.talent_status || "PENDING_REVIEW",
    talent_access_level: target?.talent_access_control?.talent_access_level || "STANDARD",
    // talent_profile_passwords: target?.talent_access_control?.talent_profile_passwords || {},
    talent_profile_passwords:
  Array.isArray(target?.talent_access_control?.talent_profile_passwords)
    ? target.talent_access_control.talent_profile_passwords
    : Object.values(target?.talent_access_control?.talent_profile_passwords || []),
    talent_profile_password_expiration_date: target?.talent_access_control?.talent_profile_password_expiration_date || dateFormat_0(new Date().setUTCDate(new Date().getUTCDate() + 7)),
    talent_is_published: !target ? "PUBLISHED" : target?.talent_is_published === true ? "PUBLISHED" : "UNPUBLISHED" ,
    talent_sector_industry: target?.talent_sector_industry
  }

  const missingFieldsInit = {
    talent_full_name: false,
    talent_pseudonym: false,
    talent_job_title_en: false,
    talent_resume_en: false,
    talent_salary: false,
    talent_location: false,
    // talent_location_country: false,
    // talent_location_state: false,
    // talent_location_city: false,
    talent_sector_industry: false
  }


const [data, setData] = useState(blankDataInit)
const [selectedTags, setSelectedTags] = useState(null)
const [selectedLevel1Tags, setSelectedLevel1Tags] = useState(targetAssociatedLevel1Tags)
const [selectedLevel2Tags, setSelectedLevel2Tags] = useState(targetAssociatedLevel2Tags)
const [selectedLevel3Tags, setSelectedLevel3Tags] = useState(targetAssociatedLevel3Tags)
const [tagsTable, setTagsTable] = useState(null)
const [previewOpen, setPreviewOpen] =useState(true)
const [fieldInFocus, setFieldInFocus]= useState(null)
const [missingFields, setMissingFields] = useState(missingFieldsInit)
const [loading, setLoading] = useState(false)
const [fileUploadDialogOpen, setFileUploadDialogOpen] = useState(false)
const [fileData, setFileData] = useState(null)
const [filePreview, setFilePreview] = useState(null)
// const [privateTalentHasDuplicatePasswords, setPrivateTalentHasDuplicatePasswords] = useState(false)
// const [privateTalentHasDuplicateContactNames, setPrivateTalentHasDuplicateContactNames] = useState(false)
// const [talentProfilePasswordKeyValuePairs, setTalentProfilePasswordKeyValuePairs] = useState(0)




useEffect(() => {

  
  if (target) {
    setData(targetDataInit)
    // set selected primary and secondary tags of a target to what's already associated. This is later updated in callback from handleTagsCallback. 
    setSelectedLevel1Tags(targetAssociatedLevel1Tags)
    setSelectedLevel2Tags(targetAssociatedLevel2Tags)
    setSelectedLevel3Tags(targetAssociatedLevel3Tags)
    // setTalentProfilePasswordKeyValuePairs(Object.keys(targetDataInit.talent_profile_passwords).length)
  }
  else {
    console.log("BLANKDATAINIT", blankDataInit)
    setData(blankDataInit)
    setSelectedLevel1Tags([])
    setSelectedLevel2Tags([])
    setSelectedLevel3Tags([])
  }




  const getTags = async () => {
    try {
      let apiUrl = `/api/tags/`;
      let response = await fetch(apiUrl, {
        method: `GET`,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
        credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
      });

      response = await response.json();

      setTagsTable(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  getTags()


}, [target]);


  // const handleChildCallback = cb => {
  //   // RadioButtonCommunicationLanguage
  //   if (cb.communication_language) {setData({...data, communication_language: cb.communication_language})}
  //   // if (cb.star_rating) {callback({refreshData: true})}
  // }

  const handleTagsCallback = cb => {
    console.log('Callback@HandleTagsCallback', cb)
  if (cb.lvlOne) {  // lvl1
    setSelectedLevel1Tags(cb.lvlOne.newTags)
    // if (cb.lvlOne.newTags === null) {
    //   setSelectedLevel2Tags([])
    //   setSelectedLevel3Tags([])
    // }
  }
  if (cb.lvlTwo) { // lvl2
    setSelectedLevel2Tags(cb.lvlTwo.newTags)
  }
  if (cb.lvlThree) { // lvl3
    setSelectedLevel3Tags(cb.lvlThree.newTags)
  }
  }

  const handleDatePickerCallback = cb => {
    // console.log('cbDatepicker', cb)
    setData({...data, talent_profile_password_expiration_date: cb.datePicker})
    // console.log(data)
  }

const addPassword = () => {
  if (data.talent_profile_passwords.length > 1 && (!user?.user_billing?.tier || user?.user_billing?.tier === 'FREE')) {
    state.setError({message: 'Free accounts are limited to 2 passwords'})
    return;
  }
  setData(prev => ({
    ...prev,
    talent_profile_passwords: [
      ...prev.talent_profile_passwords,
      { contact_name: '', contact_password: '' }
    ]
  }));
};

  const handlePasswordChange = (index, field, value) => {

    console.log(index, field, value)
        // Ensure no two passwords are the same (otherwise it'll confuse the system as to which contact visited profile)
    // data.talent_profile_passwords.reduce((prev, current)=>{if (prev.contact_password === current.contact_password){
    //   state.setError({message: 'Passwords cannot match!'})
    // }} )

  setData(prev => {
    const next = [...prev.talent_profile_passwords];

    // HARD LOCK: first contact name is always INIT
    // if (index === 0 && field === 'contact_name') {
    //   next[0] = {
    //     ...next[0],
    //     contact_name: 'INIT'
    //   };
    // }
    // else {
      next[index] = {
      ...next[index],
      [field]: value
    };
  // }

  // Extract non-empty passwords
    const passwords = next
      .map(p => p.contact_password)
      .filter(Boolean);

    // Extract non-empty passwords
      const contactNames = next
      .map(p => p.contact_name)
      .filter(Boolean)
      .map(n => n.trim().toUpperCase());

    // Check for duplicates
    const hasDuplicatePasswords = new Set(passwords).size !== passwords.length;
    const hasDuplicateContactNames = new Set(contactNames).size !== contactNames.length;

    // setPrivateTalentHasDuplicatePasswords(hasDuplicatePasswords) // later used in handleSubmit
    // setPrivateTalentHasDuplicateContactNames(hasDuplicateContactNames)
    if (hasDuplicatePasswords || hasDuplicateContactNames) {
      state.setError({ message: 'Passwords and contact names cannot be duplicate' });
      // return prev; // ❌ block state update
    }
    else {
    // Clear error if previously set
    state.setError(false);
    }

    return {
      ...prev,
      talent_profile_passwords: next
    };
  });
  console.log(data.talent_profile_passwords)
};



const handleDeletePassword = (indexToDelete) => {
  if (data.talent_access_level === 'PRIVATE' && data.talent_profile_passwords.length < 2) {
    console.log('len', data.talent_profile_passwords.length)
    state.setError({message: "The talent is currently set to private, you must at least have one password"})
    return;
  }
  setData(prevData => ({
    ...prevData,
    talent_profile_passwords: prevData.talent_profile_passwords.filter(
      (_, index) => index !== indexToDelete
    )
  }));
};



  const handleRadioButtonCallback = cb => {
    // console.log('callback@TalentModal', cb)
    if (cb.talent_type) {setData({...data, talent_type: cb.talent_type})}
    if (cb.talent_is_published) {setData({...data, talent_is_published: cb.talent_is_published})} // this is a str, not a Bool, it's converted to Bool in backend (post / put request)
    if (cb.talent_status) {setData({...data, talent_status: cb.talent_status})}
    // talent access control 
    if (cb.talent_access_level) {
      setData({...data, talent_access_level: cb.talent_access_level})
      if (cb.talent_access_level === 'PRIVATE'){addPassword}
    }
    if (cb.talent_salary_period) {
      setData({...data, talent_salary_period: cb.talent_salary_period})
    }
    // callback({action: "presetFilterApplied", presetFilterQuery: cb})
  }

  const handleSectorSelectCallback = cb => {
    // console.log('CB@SECTOR', cb)
     setData({ ...data, talent_sector_industry: cb ? cb : null })
    //  console.log("XDATA", data)
  }


  const handleClose = async () => {
    state.setTalentModalOpen(false)
    callback({resetTarget: true})
  }



  const handleChange = (event, index) => {
    // console.log("DATA", data)
    // console.log("NDX", index)
    // console.log(event)
    // setData({
    //   ...data,
    //   [event.target?.name]: event.target?.value,
    // });
    // console.log(data);
    if (event.target?.name ==='talent_salary') {
      setData((prevData) => ({
        ...prevData,
        [event.target?.name]: event.target.value.replace(/\D/g, '')
      }));
      return;
    }

    // PASS KEY
    // else if (event.target?.name.startsWith('talent_profile_password_key_')){
    //           console.log(data.talent_profile_passwords)
    //   console.log('TARNAME', event.target?.name)
    //     setData((prevData) => ({
    //     ...prevData,
    //     talent_profile_passwords: {
    //       ...prevData.talent_profile_passwords, // keep all other keys
    //       // [index]: {contact_name: event.target?.value} // update only this key
    //       [index]: {
    //       // ...prevData.talent_profile_passwords[index],
    //         ...(prevData.talent_profile_passwords?.[index] || {}),
    //       contact_name: event.target.value // update only this key
    //     }     
    //     }
    //   }));
    //   return;
    // }
    //   // PASS VALUE
    //   else if (event.target?.name.startsWith('talent_profile_password_value_')){
    //     console.log(data.talent_profile_passwords)
    //   console.log('TARNAME', event.target?.name)
    //     setData((prevData) => ({
    //     ...prevData,
    //     talent_profile_passwords: {
    //       ...prevData.talent_profile_passwords, // keep all other keys
    //     [index]: {
    //       ...prevData.talent_profile_passwords[index],
    //       contact_password: event.target.value // update only this key
    //     }        
    //   }
    //   }));
    //   return;
    // }

    setData((prevData) => ({
      ...prevData,
      [event.target?.name]: event.target?.value,
    }));
  
    if(event.target?.value.length > 1){setMissingFields((prevMissingFields) => ({
      ...prevMissingFields,
      [event.target?.name]: false, // Mark the field as not missing
    }));}

  };



//   const computeDuplicates = (passwords) => {
//   const pw = passwords.map(p => p.contact_password).filter(Boolean);
//   const names = passwords
//     .map(p => p.contact_name)
//     .filter(Boolean)
//     .map(n => n.trim().toUpperCase());

//   return {
//     hasDuplicatePasswords: new Set(pw).size !== pw.length,
//     hasDuplicateContactNames: new Set(names).size !== names.length
//   };
// };

const validateTalentProfilePasswords = (entries) => {
  const normalizedNames = [];
  const passwords = [];

  let hasEmptyContactName = false;
  let hasEmptyPassword = false;

  for (const p of entries) {
    const name = p.contact_name?.trim();
    const password = p.contact_password?.trim();

    if (!name) hasEmptyContactName = true;
    if (!password) hasEmptyPassword = true;

    if (name) normalizedNames.push(name.toUpperCase());
    if (password) passwords.push(password);
  }

  return {
    hasEmptyContactName,
    hasEmptyPassword,
    hasDuplicateContactNames:
      new Set(normalizedNames).size !== normalizedNames.length,
    hasDuplicatePasswords:
      new Set(passwords).size !== passwords.length
  };
};


  const handleSubmit = async () => {
    setLoading(true)



  // 1️⃣ Generate UUID for THIS record
  const recordUUID = crypto.randomUUID();

  // 2️⃣ Build the payload ONCE (source of truth)
  let recordPayload;
  if (target){ // if editing
    recordPayload = {
        ...data, // build as is
    };
  } else { // if new post or comment or reply
      recordPayload = {
        ...data,
        talent_uuid:recordUUID,
    };
  }



  /*------------------------------
    File upload (uses SAME UUID)
    unused right now (feb 20 2026)
  -------------------------------*/
  if (fileData?.file) {
    const formData = new FormData();
    formData.append("file", fileData.file, fileData.file_name);
    formData.append("file_name", fileData.file_name);
    formData.append("file_extension", fileData.file_extension);
    formData.append("user", JSON.stringify(user));
    // formData.append("record_data", JSON.stringify(recordPayload))

    let mediaUploadResponse = await fetch(
      `/api/services/files?user_type=${user.user_type}&file_type=DOCUMENT&parent_record_uuid=${target ? target.talent_uuid : recordUUID}&record_type=TALENT`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
      }
    );

    console.log(mediaUploadResponse.status)


    if (mediaUploadResponse.status !== 200) {

      mediaUploadResponse.status === 401 && deleteTalnetBrowserCookies()

      console.log('ERROR: ', mediaUploadResponse)
      mediaUploadResponse = await mediaUploadResponse.json()
      state.setError({message: `Couldn't upload file. Error: ${mediaUploadResponse.error.message || mediaUploadResponse.error  }`})
      setLoading(false);
      return;
    }
  }

    // Log missing fields after they've been updated
    // console.log("MISSING FIELDS: ", tempMissingFields);
    // console.log("DUPS", privateTalentHasDuplicateContactNames, privateTalentHasDuplicatePasswords)
    // if (privateTalentHasDuplicatePasswords === true || privateTalentHasDuplicateContactNames === true) {
    //   state.setError({message: 'Profile cannot have duplicate passwords or contact names'})
    //   setLoading(false)
    //   return;
    // }


    // const { hasDuplicatePasswords, hasDuplicateContactNames } = computeDuplicates(data.talent_profile_passwords);
    // if (hasDuplicatePasswords || hasDuplicateContactNames) {
    //   state.setError({ message: 'Profile cannot have duplicate passwords or contact names' });
    //   setLoading(false);
    //   return; // ⛔ HARD STOP
    // }


    // console.log("SubmitData", data)
    const tempMissingFields = validateRequiredFieldsManually(data, false, [...Object.keys(missingFieldsInit)])
    setMissingFields(tempMissingFields)
    /*----------------------------------------------------------
      [1] Validate passwords and contact names for private profile
    ----------------------------------------------------------*/
    const {
      hasEmptyContactName,
      hasEmptyPassword,
      hasDuplicateContactNames,
      hasDuplicatePasswords
    } = validateTalentProfilePasswords(data.talent_profile_passwords);
    if (data.talent_access_level === 'PRIVATE' && (hasEmptyContactName || hasEmptyPassword)) {
      state.setError({
        message: 'Contact name and password cannot be empty'
      });
      setLoading(false);
      return;
    }
    if (hasDuplicateContactNames || hasDuplicatePasswords) {
      state.setError({
        message: 'Contact names and passwords must be unique'
      });
      setLoading(false);
      return;
    }
  
    /*----------------------------------------------------------
      [2] Validate missing fields
    ----------------------------------------------------------*/
    // If there are any missing fields, do not proceed with form submission
    if (Object.values(tempMissingFields).includes(true)) {
      // Create a string listing the keys of missing fields
      const missingFieldsList = Object.keys(tempMissingFields)
      .filter(key => tempMissingFields[key] === true) // Filter for missing fields
      .join(', '); // Join them into a string

      state.setError({message: lang==='fr' ? `Champs obligatoires manquants: ${missingFieldsList}` : `Missing Required Fields: ${missingFieldsList}`})
      setLoading(false)
      return;
    }

    

        try {
        
          let apiUrl = target ? `/api/talent/?id=${target.id}&user_type=${user.user_type}` : `/api/talent/?user_type=${user.user_type}`
          let response = await fetch(apiUrl, {
            method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
            headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json'
            },
            credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            body: JSON.stringify({data: recordPayload, tags:{LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags, LEVEL_3: selectedLevel3Tags}, user: user}), // Convert the credentials object to a JSON string
            // body: data
          });

        response = await response.json()
        if (response.success === true ) {
          state.setSuccess({message: 'Profile created / updated'})
          callback({refreshData: true})
          callback({resetTarget: true})
          handleClose()
          // setLoading(false)
          // state.setTalentModalOpen(false)
        }
        else { 
          state.setError({message: <>There was a problem creating / updating this profile<br/>Error: {response.message}</>})
          console.log(response)
          // setLoading(false)
        }
        callback({refreshData: true})
            
        } catch (error) {
          console.log('error', error)
          setLoading(false)
        } finally {
          setLoading(false)
        }
  };




    const handleFileUpload = (cb) => {

    if (cb.action === 'fileUpload') {
      setFileData({...fileData, file_name: standardizeFileName(cb.file.name), file_extension: cb.file.name.split('.')[1], file: cb.file})
      setFilePreview(URL.createObjectURL(cb.file))
    }

        if (cb === 'closeDialog' || cb === 'isDropped') {
      setFileUploadDialogOpen(false)
    }

    // if (cb === 'closeDialog' || cb === 'isDropped') {
    //   setFileUploadDialogOpen(false)
    // }
  }


  return (
    <>
{/* <div class="right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform translate-x-full"> */}
<div
  className={`right-0 top-0 overflow-x-hidden fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
    state.talentModalOpen === true ? 'translate-x-0' : 'translate-x-full'
  }`}
>

            <div key={target?.id} className="lg:mb-0 px-4 w-full h-screen lg:sticky top-0 overflow-auto no-scrollbar lg:flex flex-col justify-center">
              {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

              <div className={`mt-0 absolute duration-300 ease-in-out transition-transform transform ${previewOpen ? 'left-0 md:w-7/12' : 'right-0 md:w-7/12'} top-0 min-h-screen w-full`}>
                {/*content*/}
                <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}

                  <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => {
                    // state.setTalentModalOpen(false)
                    handleClose()
                    }}
                    helpUrl={'https://talnet.co/space/docs/#talent'}
                    />

   

   
                  <div className="relative p-6 flex-auto text-left">
                    <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-slate-200">

                    {/* <div className="col-span-5 w-6/12 mx-auto text-left"> */}



                  <div className="flex grid lg:grid-cols-12 gap-1 mt-2 mb-2">

                        <div className="lg:col-span-6 w-full justify-left">
                        <FormSubHeading data={'Talent Publication'}/>
                        <RadioButton_1
                          name="talentIsPublishedRadioSwitch"
                          value1={"PUBLISHED"}
                          value2={"UNPUBLISHED"}
                          caption1="Published"
                          caption2="Unpublished"
                          defaultChecked={target ? data.talent_is_published : "PUBLISHED"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'talent_is_published'}
                        />
                    </div><div className="lg:col-span-6 w-full justify-left">
                      <FormSubHeading data={'Talent Access Control'}/>
                        <RadioButton_1
                          name="talentAccessControlRadioSwitch"
                          value1={"PUBLIC"}
                          value2={"STANDARD"}
                          value3={"PRIVATE"}
                          caption1="Public"
                          caption2="Standard"
                          caption3="Private"
                          defaultChecked={target && data.talent_access_level || "STANDARD"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'talent_access_level'}
                        />
                  </div>
                  </div>

                  <div className={`${data.talent_access_level === "PRIVATE" ? 'flex grid' : 'hidden'} lg:grid-cols-12 gap-2 mt-2 mb-2`}>

              
                  <div className="lg:col-span-12 w-full justify-left">
                                            <FormSubHeading data={lang === 'fr' ? 'Date Expiration mot de Passe' : 'Password Expiration Date'}/>
                  {/* <InputText data={{type: 'text', id:'talent_profile_password_expiration_date', name: 'talent_profile_password_expiration_date', value: data.talent_profile_password_expiration_date , onChange: handleChange, label: 'Password Expiration Date'}}/> */}
                  <DatePicker callback={handleDatePickerCallback} targetDate={data.talent_profile_password_expiration_date }/>
                  </div>


                  {/* {target && Object.keys(target.talent_access_control.talent_profile_passwords).map((key, index) => {
                      let fieldKey = index + 1; 
                      return (
                        <Fragment key={key}>
                          <div className="lg:col-span-6 w-full justify-left">
                            <InputText
                              darkBGValue={'dark:bg-slate-900'}
                              name={`talent_profile_password_key_${index + 1}`}
                              data={{
                                type: 'text',
                                id: `talent_profile_password_key_${index + 1}`,
                                value: data.talent_profile_passwords[fieldKey]['contact_name'] || target.talent_access_control.talent_profile_passwords[fieldKey]['contact_name'] ,
                                onChange: (e)=>handleChange(e, 1),
                                label: `Contact Name`
                              }}
                            />
                          </div>
                          <div className="lg:col-span-6 w-full justify-left">
                            <InputText
                                      darkBGValue={'dark:bg-slate-900'}
                              name={`talent_profile_password_value_${index + 1}`}
                              data={{
                                type: 'password',
                                id: `talent_profile_password_value_${index + 1}`,

                                value: data.talent_profile_passwords[fieldKey]['contact_password'] || target.talent_access_control.talent_profile_passwords[fieldKey]['contact_password'],
                                onChange: e=>handleChange(e, 1),
                                label: 'Password'
                              }}
                            />
                          </div>
                        </Fragment>
                      );
                    })} */}








                  {/* extra password kv pairs */}
                  {data.talent_profile_passwords.map((item, index) => {
                    return (
  <Fragment key={index}>
    <div className="lg:col-span-6 w-full">
      <InputText
        // defaultValue={index === 0 ? 'INIT' : ''}
        darkBGValue="dark:bg-slate-900"
        data={{
          disabled:index === 0, // if first password, disable it as 1st contact name is always GLOBAL
          type: 'text',
          value: index === 0 ? 'INIT' : item.contact_name, // if first password, disable it as 1st contact name is always GLOBAL
          onChange: e =>
            handlePasswordChange(index, 'contact_name', e.target.value),
          label: 'Contact Name'
        }}
      />
    </div>

    <div className="lg:col-span-5 w-full">
      <InputText
        darkBGValue="dark:bg-slate-900"
        data={{
          type: 'password',
          value: item.contact_password,
          onChange: e =>
            handlePasswordChange(index, 'contact_password', e.target.value),
          label: 'Password'
        }}
      />
    </div>
    {/* <div className="lg:col-span-1 w-full cursor-pointer flex items-center justify-center hover:text-slate-400 transition-all duration-300" onClick={()=>handleDeletePassword(index)}><i className="fa-solid fa-minus text-xl"></i></div> */}
    <MinusButton onClick={()=>handleDeletePassword(index)}/>
  </Fragment>
)})}

                  <div className="lg:col-span-12 w-full justify-left">
                  <TealButton caption={lang === 'fr' ? <div className="flex items-center justify-center">
                  <i className="fa-solid fa-plus text-lg mr-1"></i>Ajouter un Mot de Passe
                  </div> : <div className="flex items-center justify-center">
                  <i className="fa-solid fa-plus text-lg mr-1"></i>Add a Password
                  </div>} onClick={ ()=>{addPassword()}}/>
                  </div>
                  {/*  */}







                  </div>

              

              
                  <div className="flex grid lg:grid-cols-12 gap-1 align-middle mb-2">
                      <div className="lg:col-span-6 w-full">
                      <InputText 
                       darkBGValue={'dark:bg-slate-900'}

                        name='talent_full_name' 
                        data={{type: 'text',
                          id:'talent_full_name', value: data.talent_full_name , onChange: e=>handleChange(e), label: 'Full Name'}}
                        error={missingFields['talent_full_name'] === true}
                      />
                        </div>
                        <div className="lg:col-span-6 w-full">
                        <InputText 
                            darkBGValue={'dark:bg-slate-900'}

                          name='talent_pseudonym' 
                          error={missingFields['talent_pseudonym'] === true}
                          data={{type: 'text', id:'talent_pseudonym',  value: data.talent_pseudonym , onChange: e=>handleChange(e) , label: 'Pseudonym'}}/>
                        </div>
                        </div>

                        



               
                          
                      <div className="flex grid lg:grid-cols-2 gap-1 align-middle mb-2">
                      <div className={`${user.user_languages?.working?.includes("FRENCH") ? 'lg:col-span-1' : 'lg:col-span-2'} w-full`}>
                      <InputText  
                       darkBGValue={'dark:bg-slate-900'}
                        name='talent_job_title_en' 
                        error={missingFields['talent_job_title_en'] === true}
                        data={{type: 'text',
                        id:'talent_job_title_en', value: data.talent_job_title_en , onChange: e=>handleChange(e), label: 'Job Title English'}}/>
                        </div>     
                        {user.user_languages?.working?.includes("FRENCH") && <div className="lg:col-span-1 w-full">
                        <InputText 
                        darkBGValue={'dark:bg-slate-900'}
                        name='talent_job_title_fr' 
                        error={missingFields['talent_job_title_fr'] === true}
                        data={{type: 'text', id:'talent_job_title_fr',  value: data.talent_job_title_fr, onChange: e=>handleChange(e), label: 'Job Title French'}}/>
                      </div>}
                      </div>

                      <div className="flex grid lg:grid-cols-4 gap-1 mb-2">
                        <div className="lg:col-span-1 w-full">


                    <DivisionSelect
                      missingRequired={missingFields['talent_sector_industry'] === true ? true : false}
                      parentField={'talent_sector_industry'}
                      onChange={()=>{}}
                      lang={lang}
                      // callback={(x)=>handleSectorSelectCallback('job_sector_industry', x)}
                      callback={handleSectorSelectCallback}
                        target={target}
                        placeholder={lang === 'fr' ? "Secteur du Talent" : 'Talent Sector'}
                      />
                  
                      {/* <SectorSelect  
                      missingRequired={missingFields['talent_sector_industry'] === true}
                      lang={'en'}
                      onChange={()=>{}}
                      parentField={'talent_sector_industry'}
                      callback={handleSectorSelectCallback}
                        target={target}
                        // onChange={(selection) => { setData({ ...data, job_employer_sector_industry: selection ? selection : null });}}
                        placeholder={'Sector'}
                      /> */}
                      </div>
                      <div className="lg:col-span-1 w-full">
                      <TagsAssociationSelect isMulti={false} tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={1} target={target} placeholder={lang === 'fr' ? "Tags Niveau 1" : "Level 1 Tags"} selectedParent={data.talent_sector_industry?.id}/>
                      </div>
                      <div className="lg:col-span-1 w-full">
                      <TagsAssociationSelect tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={2} target={target} placeholder={'Level 2 Tags'} selectedParent={data.talent_sector_industry?.id} selectedParentTag={selectedLevel1Tags}/>
                      </div>
                      <div className="lg:col-span-1 w-full">
                      <TagsAssociationSelect tagsTable={tagsTable} callback={handleTagsCallback} target={target} tagsLevel={3}  placeholder={'Level 3 Tags'} selectedParent={data.talent_sector_industry?.id}/>
                      </div>
                      </div>
                      {/* <DatePicker callback={handleDatePickerCallback} targetDate={target?.talent_expiration_date}/> */}




                      <div className="col-span-4 space-y-2">
   {/* <InputText data={{type: 'text', id:'talent_title_en', name: 'talent_title_en', value: data.talent_title_en , onChange: handleChange, label: 'Job Title English'}}/>

 
   <InputText data={{type: 'text', id:'talent_title_fr', name: 'talent_title_fr', value: data.talent_title_fr, onChange: handleChange, label: 'Job Title French'}}/> */}



<div className="flex grid lg:grid-cols-12 gap-1 align-middle mb-2">

  
                      {/* <div className="lg:col-span-6 w-full">
                          
              <LocationSelect
              missingRequired={missingFields['talent_location'] === true}
              value = {data.talent_location ? {value: data.talent_location, label: data.talent_location} : ''}
                              placeholder={'Location'}
                              onChange={(selection) => {
                                setData({ ...data, talent_location: selection ? selection.value : null });
                                console.log('selected', selection);
                              }}
                            />
</div> */}




    <div className="lg:col-span-12 w-full">
<LocationSelectGeoNames
  missingRequired={missingFields['talent_location'] === true ? true : false}
  name="talent_location"
  id="talent_location"
  placeholder="Start typing in the city name..."
  value={
    data.talent_location
      ? {
          value: data.talent_location.value,
          label: data.talent_location.label
        }
      : null
  }
  // value= { newUserData.user_location || null}
  onChange={(selection) => {
    console.log("SELECTION", selection)
    setData({
      ...data,
      talent_location: selection
    });
    selection?.value ? setMissingFields({...missingFields, talent_location: false }) : setMissingFields({...missingFields, talent_location: true })
  }}
/>

</div>




{/* OLD LOCATIONS */}
                       {/* <div className="lg:col-span-4 w-full">

               <LocationSelect
              missingRequired={missingFields['talent_location_country'] === true ? true : false}
              zoomLevel={'COUNTRIES'}
              value = {data.talent_location_country ? {value: data.talent_location_country, label: humanizeString(data.talent_location_country)} : user.user_location?.country ? {value: user.user_location.country, label: humanizeString(user.user_location.country)}: ''} 
              placeholder={lang === 'fr' ? 'Pays' : 'Country'}
              onChange={(selection) => {
              setData({ ...data, talent_location_country: selection ? selection.value : null });
              selection.value && setMissingFields({...missingFields, talent_location_country: false });
              }}
            />
</div>
<div className="lg:col-span-4 w-full">
                         
                          <LocationSelect
                          missingRequired={missingFields['talent_location_state'] === true ? true : false}
                           zoomLevel={'STATES'}
                          isDisabled={!data.talent_location_country && !user.user_location.country}
                          selectedCountry={data?.talent_location_country || user?.user_location?.country}
                          value = {data.talent_location_state ? {value: data.talent_location_state, label: humanizeString(data.talent_location_state)} : ''}
                          placeholder={lang === 'fr' ? 'Province / État' : "State or Province"}
                          onChange={(selection) => {
                            setData({ ...data, talent_location_state: selection ? selection.value : null, talent_location_city: null });
                            selection.value && setMissingFields({...missingFields, talent_location_state: false })
                          }}
                                        />
            </div>
                 <div className="lg:col-span-4 w-full">
                         
                          <LocationSelect
                          missingRequired={missingFields['talent_location_city'] === true ? true : false}
                          isDisabled={!data.talent_location_state && !user.user_location.state}
                          zoomLevel={'CITIES'}
                          selectedCountry={data?.talent_location_country || user?.user_location?.country}
                          selectedState={data?.talent_location_state || user?.user_location?.state}
                          value = {data.talent_location_city ? {value: data.talent_location_city, label: humanizeString(data.talent_location_city)} : ''}
                          placeholder={lang === 'fr' ? 'Ville' : "City"}
                                          onChange={(selection) => {
                                            setData({ ...data, talent_location_city: selection ? selection.value : null });
                                            selection.value && setMissingFields({...missingFields, talent_location_city: false });
                                          }}
                                        />
            </div> */}





                      
<div className="lg:col-span-4 w-full mt-1">
              <InputText 
              darkBGValue={'dark:bg-slate-900'}
              name="talent_salary" 
              error={missingFields['talent_salary'] === true}
              data={{type: 'text',  id:'talent_salary',  value: data.talent_salary, onChange: e=>handleChange(e), label: 'Salary'}}/>
              </div>

                            <div className="lg:col-span-4 w-full mt-1 flex items-center">
  
  <CurrencySelect 
  userCountryCode = {user?.user_location?.country_code}
  placeholder={'Currency'}
  target={target?.talent_conditions} 
  parentField={'talent_salary_currency'} 
  onChange={()=>{}} 
  lang={'en'} 
  callback={cb=>{setData({...data, talent_salary_currency: cb})}}
  // callback={(x)=>{console.log(x); 
  //   setTagData({...tagData, topic_sector_industry: x})
  // }}
  />
              </div>


              <div className="lg:col-span-4 w-full mt-1 flex items-center">
                          <RadioButton_1
                          name="talentSalaryPeriodRadioSwitch"
                          value1={"YEAR"}
                          value2={"MONTH"}
                          value3={"HOUR"}
                          caption1="Per Year"
                          caption2="Per Month"
                          caption3="Per Hour"
                          defaultChecked={target ? data.talent_salary_period : "YEAR"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'talent_salary_period'}
                        />

              </div>



                  </div>

         

{/* <div className="flex grid lg:grid-cols-2 gap-1 align-middle mb-2">
                      <div className="lg:col-span-1 w-full">
                      <InputText 
                        name="url_1" 
                        error={missingFields['url_1'] === true}
                        data={{type: 'text', darkBGValue:'dark:bg-slate-900', id:'url_1',  value: data.url_1, onChange: handleChange, label: 'Url 1'}}
                      />
                        </div>
                        <div className="lg:col-span-1 w-full">
                        <InputText 
                        name="url_1" 
                        error={missingFields['url_1'] === true}
                        data={{type: 'text', darkBGValue:'dark:bg-slate-900', id:'url_1',  value: urlBuilder(data.talent_job_title_en, data.talent_location, 'en', 'TALENT'), onChange: handleChange, label: 'Url 1'}}
                      />
                        </div>
                        </div> */}

{/* <TextEditor/> */}

{/* SUMMARY */}
  {/* <textarea
                rows="20"
                className="w-full dark:bg-inherit mb-4 appearance-none border border-gray-500 dark:border-gray-600 rounded-lg py-2 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm"
                id="talent_resume_en"
                value={data.talent_resume_en}
                onChange={handleChange}
                name="talent_resume_en"
                placeholder={`Resume English...`}
              />
                <textarea
                rows="20"
                className="w-full dark:bg-inherit mb-4 appearance-none border border-gray-500 dark:border-gray-600 rounded-lg py-2 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm"
                id="talent_resume_fr"
                value={data.talent_resume_fr}
                onChange={handleChange}
                name="talent_resume_fr"
                placeholder={`Resume French...`}
              /> */}






{/* {!target && <div>
  <FileUploadDragAndDrop
  caption={<>Drag and drop or click to browse to upload your <strong>candidate's non-anonymized resume</strong><br/><span className="text-xs">This file remains hidden and is only released when you choose to share it in a submission.<br/>Click the question mark (top right) for more details.
</span></>}
              acceptedFileTypes={'documents'} 
              isCloseable={false} 
              paddingY={'sm'} lang={'en'} fileName={fileData?.file_name || ''} 
              // callback={(cb)=>{cb === 'closeDialog' && setFileUploadDialogOpen(false)}}
              callback={handleFileUpload}
              />
</div>} */}

                 {     
               user?.user_roles.role === 'ROOT' && 
               <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">
               <div className="flex gap-1 items-center rounded-2xl">
                    
              <select
                id="status_change"
                name="status_change"
                className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800"
                value={data.talent_status || ''}
                onChange={(e) => {
                  setData({
                    ...data,
                    talent_status: e.target.value
                  });
                }}
              >
                <option value="" disabled>
                  Status: {humanizeString(data.talent_status)}
                </option>

                <option value="PENDING_REVIEW">PENDING_REVIEW</option>
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
                <option value="FLAGGED">FLAGGED</option>
                <option value="REJECTED">REJECTED</option>
                <option value="ARCHIVED">ARCHIVED</option>
              </select>
               {/* <select id="status_change" name="status_change" className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800" defaultValue={''}>
               <option value="" disabled> Status: {humanizeString(data.talent_status)}</option>    
               <option onClick={(e)=>{setData({...data, talent_status: 'PENDING_REVIEW'})}} value="PENDING_REVIEW">PENDING_REVIEW</option>
               <option onClick={(e)=>{setData({...data, talent_status:'ACTIVE'})}} value="ACTIVE">ACTIVE</option>
              <option onClick={(e)=>{setData({...data, talent_status:'INACTIVE'})}} value="INACTIVE">INACTIVE</option>
               <option onClick={(e)=>{setData({...data, talent_status:'FLAGGED'})}} value="FLAGGED">FLAGGED</option>
               <option onClick={(e)=>{setData({...data, talent_status:'REJECTED'})}} value="REJECTED">REJECTED</option>
               <option onClick={(e)=>{setData({...data, talent_status:'ARCHIVED'})}} value="ARCHIVED">ARCHIVED</option>
               </select> */}
               </div>
               </div>
          }

<MarkdownEditor 
textAreaRows={25}
  textAreaName={'talent_resume_en'}
  textAreaId={'talent_resume_en'}
  callback={(x)=>{handleChange(x)}} 
  showPreview={false} 
  textAreaOnFocus={x=>setFieldInFocus('talent_resume_en')}
  // textAreaOnFocus={x=>console.log(x.target.name)}
  // textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
  textAreaRef={textAreaRef1} 
  textAreaValue={data.talent_resume_en} 
  textAreaPlaceholder={lang === 'fr' ? "Resume en Anglais" : 'Anonymized resume'}
/>
<br/>
{user.user_languages?.working?.includes("FRENCH") && <MarkdownEditor 
textAreaOnFocus={x=>setFieldInFocus('talent_resume_fr')}
textAreaRows={25}
  // textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
  textAreaName={'talent_resume_fr'}
  textAreaId={'talent_resume_fr'}
  callback={(x)=>{handleChange(x)}} 
  showPreview={false} 

  textAreaRef={textAreaRef2} 
  textAreaValue={data.talent_resume_fr} 
  textAreaPlaceholder={lang === 'fr' ? "Resume en Français" : 'Resume in French'}
/>}





                      </div>

<br/><br/>





                    </div>
                  </div>

                  {/*footer*/}
                  {/* <ModalFooter missingRequiredFields={false} closeOnClickMethod={() => state.setTalentModalOpen(false)} saveOnClickMethod1={handleSubmit} 
                  state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
                  /> */}

<ModalFooter 
                  missingRequiredFields={missingFields} 
                  loading={loading} 
                  cancelButtonCaption={lang==='fr' ? 'Annuler' : 'Cancel'} 
                  submitButtonCaption1={lang==='fr' ? <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Sauvegarder</> : <><i className="fa-solid fa-rocket mr-1"></i>Afficher</>}</> : <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Save</> : <><i className="fa-solid fa-rocket mr-1"></i>Post</>}</>} 

                  submitButtonCaption2={lang === 'fr' ? !previewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : previewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
                  saveOnClickMethod1={()=>{handleSubmit()}} 
                  saveOnClickMethod2={()=>{setPreviewOpen(!previewOpen)}}
                  // closeOnClickMethod={() => {handleClose()}} 
                  state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
                  />

                </div>
              </div>
            </div>






            <div key={target?.id+1}>
              {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}
             
              <div className={`fixed right-0 top-0 min-h-screen w-5/12 duration-300 ease-in-out transition-transform transform invisible md:visible ${
    previewOpen === true ? 'translate-x-0' : 'translate-x-full'
  }`}>
                {/*content*/}
                {/* dark:backdrop-blur-md  */}
                <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
                  
                  <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu</> : <><i className="fa-solid fa-binoculars mr-2"/>Preview</>} closeOnClickMethod={() => setPreviewOpen(false)}/>
                  {/* <div className="fixed top-0 bg-inherit flex items-center z-50 px-2 py-1 h-screen">
                    test
                  </div> */}
                  <br/>
                  <div className="px-8">
                    
                  {data && 
                  <TalentPreviewCard
                            lang={lang || 'en'}
                            data={data}
                            tags={[selectedLevel1Tags].concat(selectedLevel2Tags, selectedLevel3Tags)}

                          />
                          }
                  </div>
                  {/* col-span-1 border rounded-lg p-4 prose prose-sm max-w-none h-96 overflow-y-auto bg-white text-slate-700 whitespace-pre-wrap */}

                  {/* {data[`talent_resume_${lang || 'en'}`] && <div className={`mx-8 px-6 py-8 my-10 rounded-xl bg-white dark:bg-gray-900 shadow-lg flex-col h-full text-slate-500 dark:text-slate-300 font-inter overflow-auto whitespace-pre-wrap max-w-none `}>
              
                  <ReactMarkdownMod args={data[fieldInFocus || `talent_resume_${lang || 'en'}`]}/>

                    </div>} */}

                  {data[`talent_resume_${lang || 'en'}`] && <div className={`mx-8 px-6 py-8 my-10 rounded-xl bg-white dark:bg-gray-900 shadow-lg flex-col h-full text-slate-500 dark:text-slate-300 font-inter overflow-auto max-w-none prose prose-lg dark:prose-invert break-word`}>

                  {/* <ReactMarkdownMod_2 args={data[fieldInFocus || `job_description_${lang || 'en'}`]}/> */}
                                <ReactMarkdownMod_2>
                             {data[fieldInFocus || `talent_resume_${lang || 'en'}`]}
                                  </ReactMarkdownMod_2>

                    </div>}
   
   
                  {/* <div className="relative p-6 flex-auto text-left">
                    <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-slate-200">
                    </div>
                  </div> */}
                      
                      
                      </div>
                      </div></div>




          </div>

          {state.talentModalOpen && <ModalOverlay/>}
        </>

  );
};

export default TalentModal;















































// v2
// "use client" 
// import { useEffect, useState, useRef, use } from "react";
// import axios from "axios";

// import { useParams } from "next/navigation";
// import { humanizeString } from "@/utils/frontend/stringOps.js";
// import ModalOverlay from "../../Atoms/ModalOverlay.js";
// import ModalHeader from "./ModalHeader.js";
// import ModalFooter from "./ModalFooter.js";
// import RadioButton from "../../Atoms/Buttons/RadioButton.js";
// import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
// import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
// import LocationSelect from "../../Atoms/Select/LocationSelect.js";
// import { getCookies } from "@/utils/frontend/cookieOps.js";
// import InputText from "@/components/Atoms/inputText.js";
// import TextEditor from "../TextEditor.js";
// import TagsAssociationSelect from "@/components/Atoms/Select/TagsAssociationSelect.js";
// import DatePicker from "@/components/Atoms/FormElements/DatePicker.js";
// import SectorSelect from "@/components/Atoms/Select/SectorSelect.js";
// import { getData } from "@/utils/frontend/dataOps.js";
// import { dateFormat_0 } from "@/utils/frontend/dateOps.js";
// import { validateRequiredFieldsManually } from "@/utils/frontend/validateRequiredFieldsManually.js";
// import MarkdownEditor from "../MarkdownEditor.js";
// import TalentPreviewCard from "../Cards/TalentPreviewCard.js";
// import ReactMarkdown from 'react-markdown';
// import BorderedFrameBox from "@/components/Molecules/BorderedFrameBox.js";
// import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod.js";


// const TalentModal =  ({
//   state,
//   callback,
//   target,
//   organizationPreferences,
//   modalHeaderCaption,
//   lang
// }) => {

//   const textAreaRef1 = useRef(null);
//   const textAreaRef2 = useRef(null);

// // console.log('TRGT@TalentModal', target)
//   const user = getCookies().user

//   // console.log("TARGET@TalentModal", target)

//   // get current Primary and Secondary tag associations and set them as default values for 
//   let targetAssociatedLevel1Tags = [] // later set as State
//   let targetAssociatedLevel2Tags = [] // later set as State
//   if (target && target.tags) { 
//     target.tags.filter(tag => {tag.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : targetAssociatedLevel2Tags.push(tag)})
//   }




//   const blankDataInit = {
//     id: 0,
//     talent_full_name: '',
//     talent_pseudonym: '',
//     talent_job_title_en: '',
//     talent_job_title_fr: '',
//     talent_resume_en: '',
//     talent_resume_fr: '',
//     talent_salary: '',
//     talent_location_country: user?.user_location.country || '',
//     talent_location_state: user?.user_location.state || '',
//     talent_location_city: user?.user_location.city || '',
//     talent_status: "OPEN",
//     talent_access_level: "STANDARD",
//     talent_profile_password: '',
//     talent_profile_password_expiration_date: dateFormat_0(new Date().setUTCDate(new Date().getUTCDate() + 7)),
//     talent_is_published:  "PUBLISHED",
//     talent_sector_industry: ''
//   }


//   const targetDataInit = {
//     id: target?.id,
//     talent_full_name: target?.talent_full_name,
//     talent_pseudonym: target?.talent_pseudonym,
//     talent_job_title_en: target?.talent_job_title.en,
//     talent_job_title_fr: target?.talent_job_title.fr,
//     talent_resume_en: target?.talent_resume.en,
//     talent_resume_fr: target?.talent_resume.fr,
//     talent_salary: target?.talent_salary,
//     talent_location_country: target?.talent_location.country || user?.user_location.country,
//     talent_location_state: target?.talent_location.state || user?.user_location.state,
//     talent_location_city: target?.talent_location.city || user?.user_location.city,
//     // talent_location_country: target?.talent_location.country,
//     // talent_location_state: target?.talent_location.state,
//     // talent_location_city: target?.talent_location.city,
//     talent_status: target?.talent_status || "OPEN",
//     talent_access_level: target?.talent_access_control?.talent_access_level || "STANDARD",
//     talent_profile_password: target?.talent_access_control?.talent_profile_password,
//     talent_profile_password_expiration_date: target?.talent_access_control?.talent_profile_password_expiration_date || dateFormat_0(new Date().setUTCDate(new Date().getUTCDate() + 7)),
//     talent_is_published: !target ? "PUBLISHED" : target?.talent_is_published === true ? "PUBLISHED" : "UNPUBLISHED" ,
//     talent_sector_industry: target?.talent_sector_industry
//   }



//   let missingFieldsInit = {
//     talent_full_name: false,
//     talent_pseudonym: false,
//     talent_job_title_en: false, 
//     talent_location_country: false, 
//     talent_location_state: false, 
//     talent_location_city: false, 
//     talent_salary: false, 
//     talent_sector_industry: false, 
//     talent_resume_en: false, 
//   }


// const [data, setData] = useState(blankDataInit)
// const [selectedTags, setSelectedTags] = useState(null)
// const [selectedLevel1Tags, setSelectedLevel1Tags] = useState(targetAssociatedLevel1Tags)
// const [selectedLevel2Tags, setSelectedLevel2Tags] = useState(targetAssociatedLevel2Tags)
// const [tagsTable, setTagsTable] = useState(null)
// const [missingFields, setMissingFields] = useState(missingFieldsInit)
// const [loading, setLoading] = useState(false)
// const [previewOpen, setPreviewOpen] = useState(true)




// useEffect(() => {
//   if (target) {
//     setData(targetDataInit)
//     // set selected primary and secondary tags of a target to what's already associated. This is later updated in callback from handleTagsCallback. 
//     setSelectedLevel1Tags(targetAssociatedLevel1Tags)
//     setSelectedLevel2Tags(targetAssociatedLevel2Tags)
//   }
//   else {
//     setData(blankDataInit)
//     setSelectedLevel1Tags([])
//     setSelectedLevel2Tags([])
//   }
//   // target && setData(targetDataInit)
//   // console.log("targetDataInit", targetDataInit)
//     // set selected primary and secondary tags of a target to what's already associated. This is later updated in callback from handleTagsCallback. 
//   // setSelectedLevel1Tags(targetAssociatedLevel1Tags)
//   // setSelectedLevel2Tags(targetAssociatedLevel2Tags)
//   // console.log("SELECTED PRIMARY", targetAssociatedLevel1Tags, "SELECTED SECONDARY", targetAssociatedLevel2Tags)

//   // let getTags = async () => {
//   //   let response = await getData('tags', 'no-store', 'include')
//   //   setTagsTable(response.data)
//   // }

//   // getTags()




//   const getTags = async () => {
//     try {
//       let apiUrl = `/api/tags/`;
//       let response = await fetch(apiUrl, {
//         method: `GET`,
//         headers: {
//           Accept: "*/*",
//           "Content-Type": "application/json",
//         },
//         credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
//       });

//       response = await response.json();

//       setTagsTable(response.data);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   getTags()

 
// }, [target]);

 
// const handleTagsCallback = cb => {

//   console.log('Callback@HandleTagsCallback', cb)
//   if (cb.lvlOne) {  // primary
//     setSelectedLevel1Tags(cb.lvlOne.newTags)
//   }
//   if (cb.lvlTwo) { // secondary
//     setSelectedLevel2Tags(cb.lvlTwo.newTags)
//   }
// }

// const handleDatePickerCallback = cb => {
//   console.log('cbDatepicker', cb)
//   setData({...data, talent_profile_password_expiration_date: cb.datePicker})
//   console.log(data)
// }

// const handleRadioButtonCallback = cb => {
//   console.log('callback@TalentModal', cb)
//   if (cb.talent_type) {setData({...data, talent_type: cb.talent_type})}
//   if (cb.talent_is_published) {setData({...data, talent_is_published: cb.talent_is_published})} // this is a str, not a Bool, it's converted to Bool in backend (post / put request)
//   if (cb.talent_status) {setData({...data, talent_status: cb.talent_status})}
//   // talent access control 
//   if (cb.talent_access_level) {
//     setData({...data, talent_access_level: cb.talent_access_level})
//   }
//   // callback({action: "presetFilterApplied", presetFilterQuery: cb})
// }

// const handleSectorSelectCallback = cb => {
//   console.log(cb)
//     setData({ ...data, talent_sector_industry: cb ? JSON.stringify(cb) : null })
//     console.log("XDATA", data)
// }



  
// const { id } = useParams(); // get person / job / company ID based on current page id where component is called

// const handleChange = (event) => {

//   // setData({
//   //   ...data,
//   //   [event.target?.name]: event.target?.value,
//   // });
//   // setMissingFields({...missingFields, [event.target?.name]: false})

//   if (event.target?.name ==='talent_salary') {
     
//     setData((prevData) => ({
//       ...prevData,
//       [event.target?.name]: event.target.value.replace(/\D/g, '')
//     }));
//     return;
//   }


//   setData((prevData) => ({
//     ...prevData,
//     [event.target?.name]: event.target?.value,
//   }));

//   if(event.target?.value.length > 1){setMissingFields((prevMissingFields) => ({
//     ...prevMissingFields,
//     [event.target?.name]: false, // Mark the field as not missing
//   }));}
// };


// const handleSubmit = async () => {
//   setLoading(true)

//   // console.log("SubmitData", data)

//   // let tempMissingFields = validateRequiredFields(document.querySelectorAll('input'), missingFields)
//   const tempMissingFields = validateRequiredFieldsManually(data, false, ['talent_full_name', 'talent_pseudonym', 'talent_job_title_en', 'talent_location_country', 'talent_location_state', 'talent_location_city', 'talent_salary', 'talent_sector_industry', 'talent_resume_en'])
//   setMissingFields(tempMissingFields)


//   // Log missing fields after they've been updated
//   console.log("MISSING FIELDS: ", tempMissingFields);

//   // If there are any missing fields, do not proceed with form submission
//   if (Object.values(tempMissingFields).includes(true)) {
//     // Create a string listing the keys of missing fields
//     const missingFieldsList = Object.keys(tempMissingFields)
//     .filter(key => tempMissingFields[key] === true) // Filter for missing fields
//     .join(', '); // Join them into a string
//     state.setError({message: lang==='fr' ? `Champs obligatoires manquants: ${missingFieldsList}` : `Missing Required Fields: ${missingFieldsList}`})
//     setLoading(false)
//     return;
//   }


//       try {
      
//         let apiUrl = target ? `/api/talents/?id=${target.id}&user_type=${user.user_type}` : `/api/talents?user_type=${user.user_type}`
//         let response = await fetch(apiUrl, {
//         method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
//         headers: {
//           'Accept': '*/*',
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//         body: JSON.stringify({data: data, tags:{LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags}, user: user}), // Convert the credentials object to a JSON string
//         // body: data
//       });

//       response = await response.json()
//       if (response.success === true ) {
//         state.setSuccess({message: 'Profile created / updated'})
//         setLoading(false)
//         callback({refreshData: true})
//         callback({resetTarget: true})
//         state.setTalentModalOpen(false)
//       }
//       else { 
//         state.setError({message: 'There was a problem creating / updating this profile'})
//       }

          
//       } catch (error) {
//         console.log('error', error)
//       }
  
// };


// const handleClose = async () => {
//   state.setTalentModalOpen(false)
//   callback({resetTarget: true})
// }

  


//   return (
//     <>
// {/* <div class="right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform translate-x-full"> */}
// <div
//   className={`right-0 top-0 overflow-x-hidden fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
//     state.talentModalOpen === true ? 'translate-x-0' : 'translate-x-full'
//   }`}
// >

//             <div className="lg:mb-0 px-4 w-full h-screen lg:sticky top-0 overflow-auto no-scrollbar lg:flex flex-col justify-center" key={target?.id}>
//               {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

//               <div className={`mt-0 absolute duration-300 ease-in-out transition-transform transform ${previewOpen ? 'left-0 md:w-7/12' : 'right-0 md:w-7/12'} top-0 min-h-screen w-full  
//               `}>
//               {/* <div className={`mt-0 absolute duration-300 ease-in-out transition-transform transform top-0  min-h-screen w-full md:w-7/12 border-r-2 ${previewOpen ? 'translate-x-0' : 'translate-x-full'}`}> */}
//                 {/*content*/}
//                 <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
//                   {/*header*/}
//                   {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}

//                   <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => handleClose()}/>

   

   
//                   <div className="relative p-6 flex-auto text-left">
//                     <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-gray-100">

//                     {/* <div className="col-span-5 w-6/12 mx-auto text-left"> */}



//                   <div className="flex grid lg:grid-cols-12 gap-1 mt-2 mb-2">

//                         <div className="lg:col-span-6 w-full justify-left">
//                         <FormSubHeading data={'Talent Publication'}/>
//                         <RadioButton_1
//                           name="talentIsPublishedRadioSwitch"
//                           value1={"PUBLISHED"}
//                           value2={"UNPUBLISHED"}
//                           caption1="Published"
//                           caption2="Not Published"
//                           defaultChecked={target ? data.talent_is_published : "PUBLISHED"}
//                           callback={handleRadioButtonCallback}
//                           callbackObjectKey={'talent_is_published'}
//                         />
//                     </div><div className="lg:col-span-6 w-full justify-left">
//                       <FormSubHeading data={'Talent Access Control'}/>
//                         <RadioButton_1
//                           name="talentAccessControlRadioSwitch"
//                           value1={"PUBLIC"}
//                           value2={"STANDARD"}
//                           value3={"PRIVATE"}
//                           caption1="Public"
//                           caption2="Standard"
//                           caption3="Private"
//                           defaultChecked={target && data.talent_access_level || "STANDARD"}
//                           callback={handleRadioButtonCallback}
//                           callbackObjectKey={'talent_access_level'}
//                         />
//                   </div>
//                   </div>

//                   <div className={`${data.talent_access_level === "PRIVATE" ? 'flex grid' : 'hidden'} lg:grid-cols-12 gap-1 mt-2 mb-2`}>

//                   <div className="lg:col-span-6 w-full justify-left">
//                   <InputText name='talent_profile_password' data={{type: 'password', id:'talent_profile_password', value: data.talent_profile_password || '', onChange: handleChange, label: 'Password'}}/>
//                   </div>
//                   <div className="lg:col-span-6 w-full justify-left">
//                   {/* <InputText data={{type: 'text', id:'talent_profile_password_expiration_date', name: 'talent_profile_password_expiration_date', value: data.talent_profile_password_expiration_date , onChange: handleChange, label: 'Password Expiration Date'}}/> */}
//                   <DatePicker callback={handleDatePickerCallback} targetDate={data.talent_profile_password_expiration_date }/>
//                   </div>
//                   </div>

              

              
//                   <div className="flex grid lg:grid-cols-12 gap-1 align-middle mb-2">
//                       <div className="lg:col-span-6 w-full">
//                       <InputText error={missingFields['talent_full_name'] === true ? true : false} name='talent_full_name' data={{type: 'text', id:'talent_full_name', value: data.talent_full_name || '' , onChange: handleChange, label: 'Full Name'}}/>
//                         </div>
//                         <div className="lg:col-span-6 w-full">
//                         <InputText error={missingFields['talent_pseudonym'] === true ? true : false} required={true} name='talent_pseudonym' data={{type: 'text', id:'talent_pseudonym',  value: data.talent_pseudonym || '' , onChange: handleChange, label: 'Nickname'}}/>
//                         </div>
//                         </div>

                        



               
                          
//                       <div className="flex grid lg:grid-cols-12 gap-1 align-middle mb-2">
//                       <div className="lg:col-span-6 w-full">
//                       <InputText error={missingFields['talent_job_title_en'] === true ? true : false} name='talent_job_title_en' data={{type: 'text', id:'talent_job_title_en', value: data.talent_job_title_en || '' , onChange: handleChange, label: 'Job Title English'}}/>
//                         </div>     
//                         <div className="lg:col-span-6 w-full">
//                         <InputText name='talent_job_title_fr' data={{type: 'text', id:'talent_job_title_fr',  value: data.talent_job_title_fr || '', onChange: handleChange, label: 'Job Title French'}}/>
//                       </div>
//                       </div>

//                       <div className="flex grid lg:grid-cols-6 gap-1 mb-2">
//                       <div className="lg:col-span-3 w-full">
//                       <TagsAssociationSelect tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={1} target={target} placeholder={'Primary Tags'}/>
//                       </div>
//                       <div className="lg:col-span-3 w-full">
//                       <TagsAssociationSelect tagsTable={tagsTable} callback={handleTagsCallback} target={target} tagsLevel={2}  placeholder={'Secondary Tags'}/>
//                       </div>
//                       </div>
//                       {/* <DatePicker callback={handleDatePickerCallback} targetDate={target?.talent_expiration_date}/> */}




//                       <div className="col-span-4 space-y-2">
//    {/* <InputText data={{type: 'text', id:'talent_title_en', name: 'talent_title_en', value: data.talent_title_en , onChange: handleChange, label: 'Job Title English'}}/>

 
//    <InputText data={{type: 'text', id:'talent_title_fr', name: 'talent_title_fr', value: data.talent_title_fr, onChange: handleChange, label: 'Job Title French'}}/> */}



// <div className="flex grid lg:grid-cols-3 gap-1 align-middle mb-2">
//                       <div className="lg:col-span-1 w-full">

//               <LocationSelect
//               missingRequired={missingFields['talent_location_country'] === true ? true : false}
//               zoomLevel={'COUNTRIES'}
//               value = {data.talent_location_country ? {value: 'data.talent_location_country', label: humanizeString(data.talent_location_country)} : user.user_location?.country ? {value: user.user_location.country, label: humanizeString(user.user_location.country)}: ''} 
//               placeholder={lang === 'fr' ? 'Pays' : 'Country'}
//               onChange={(selection) => {
//               setData({ ...data, talent_location_country: selection ? selection.value : null });
//               selection.value && setMissingFields({...missingFields, talent_location_country: false });
//               }}
//             />
// </div>

{/* <div className="lg:col-span-1 w-full">
                         
                          <LocationSelect
                          missingRequired={missingFields['talent_location_state'] === true ? true : false}
                           zoomLevel={'STATES'}
                          isDisabled={!data.talent_location_country && !user.user_location.country}
                          selectedCountry={data?.talent_location_country || user?.user_location?.country}
                          value = {data.talent_location_state ? {value: data.talent_location_state, label: humanizeString(data.talent_location_state)} : ''}
                          placeholder={lang === 'fr' ? 'Province / État' : "State or Province"}
                          onChange={(selection) => {
                            setData({ ...data, talent_location_state: selection ? selection.value : null, talent_location_city: null });
                            selection.value && setMissingFields({...missingFields, talent_location_state: false })
                          }}
                                        />
            </div> */}

            // <div className="lg:col-span-1 w-full">
                         
            //               <LocationSelect
            //               missingRequired={missingFields['talent_location_city'] === true ? true : false}
            //               isDisabled={!data.talent_location_state && !user.user_location.state}
            //               zoomLevel={'CITIES'}
            //               selectedCountry={data?.talent_location_country || user?.user_location?.country}
            //               selectedState={data?.talent_location_state || user?.user_location?.state}
            //               value = {data.talent_location_city ? {value: data.talent_location_city, label: humanizeString(data.talent_location_city)} : ''}
            //               placeholder={lang === 'fr' ? 'Ville' : "City"}
            //                               onChange={(selection) => {
            //                                 setData({ ...data, talent_location_city: selection ? selection.value : null });
            //                                 selection.value && setMissingFields({...missingFields, talent_location_city: false });
            //                               }}
            //                             />
            // </div>
// <div className="lg:col-span-1 w-full">


//                       </div>
                      
//                       </div>
//                       <div className="flex grid lg:grid-cols-2 gap-1 align-middle mb-2">
//                       <div className="lg:col-span-1 w-full">
//               <InputText 
//               error={missingFields['talent_salary'] === true ? true : false}
//               name="talent_salary" data={{type: 'text', id:'talent_salary',  value: data.talent_salary || '', onChange: handleChange, label: 'Salary'}}/>
//               </div>
           
//                       <div className="lg:col-span-1 w-full">
//               <SectorSelect  
//               missingRequired={missingFields['talent_sector_industry'] === true ? true : false}
//               isMulti={false}
//               lang={lang}
//               parent={'TALENT'}
//                       callback={handleSectorSelectCallback}
//                       // callback={()=>{}}
//                         target={target}
//                         onChange={(selection)=>{
//                           selection.value && setMissingFields({...missingFields, talent_sector_industry: false})
//                           // console.log('sel', selection)
//                         }}
//                         // onChange={(selection) => { console.log(selection); setData({ ...data, talent_sector_industry: selection ? selection: null });}}
//                         placeholder={lang === 'fr' ? 'Secteur / Industrie' : 'Sector / Industry'}
//                       />
//               </div>
//               </div>
// {/* <TextEditor/> */}

// {/* <BorderedFrameBox
//                     title={lang === 'fr' ? 'EMPLOIS SIMILAIRES' : <>Url Settings</>} 
//                     body={ 'test'}
//                     /> */}


// <br/><br/>
// <MarkdownEditor 
//   textAreaName={'talent_resume_en'}
//   textAreaId={'talent_resume_en'}
//   callback={(x)=>{handleChange(x)}} 
//   showPreview={false} 
//   // textAreaOnChange={handleChange} 
//   textAreaRef={textAreaRef1} 
//   textAreaValue={data.talent_resume_en} 
//   textAreaPlaceholder={lang === 'fr' ? "CV en Anglais" : 'Resume in English'}
// />
// <br/>
// {user.user_languages?.working?.includes("FRENCH") && <MarkdownEditor 
//   textAreaName={'talent_resume_fr'}
//   textAreaId={'talent_resume_fr'}
//   callback={(x)=>{handleChange(x)}} 
//   showPreview={false} 
//   // textAreaOnChange={handleChange} 
//   textAreaRef={textAreaRef2} 
//   textAreaValue={data.talent_resume_fr} 
//   textAreaPlaceholder={lang === 'fr' ? "CV en Français" : 'Resume in French'}
// />}
// {/* SUMMARY */}
//   {/* <textarea
//                 rows="20"
//                 className="w-full dark:bg-inherit mb-4 appearance-none border border-slate-400 dark:border-slate-600 rounded-lg py-2 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm"
//                 id="talent_resume_en"
//                 value={data.talent_resume_en || ''}
//                 onChange={handleChange}
//                 name="talent_resume_en"
//                 placeholder={`Resume English...`}
//               /> */}
//                 {/* <textarea
//                 rows="20"
//                 className="w-full dark:bg-inherit mb-4 appearance-none border border-slate-400 dark:border-slate-600 rounded-lg py-2 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm"
//                 id="talent_resume_fr"
//                 value={data.talent_resume_fr || ''}
//                 onChange={handleChange}
//                 name="talent_resume_fr"
//                 placeholder={`Resume French...`}
//               /> */}



//                       </div>

// <br/><br/>





//                     </div>
//                   </div>

//                   {/*footer*/}
//                   <ModalFooter 

//                     submitButtonCaption1={lang === 'fr' ? target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Sauvegarder</> : <><i className="fa-solid fa-rocket mr-1"/>Publier</> : target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Save Changes</> : <><i className="fa-solid fa-rocket mr-1"/>Publish</>}

//                     submitButtonCaption2={lang === 'fr' ? !previewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : previewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
                    
//                     saveOnClickMethod2={()=>{setPreviewOpen(!previewOpen)}}
//                     lang={lang} missingRequiredFields={missingFields} closeOnClickMethod={() => {handleClose()}} saveOnClickMethod1={()=>{handleSubmit()}} 
//                     state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
//                   />

//                 </div>
//               </div>
//             </div>





//             <div key={target?.id+1}>
//               {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

//               <div className={`fixed right-0 top-0 min-h-screen w-5/12 duration-300 ease-in-out transition-transform transform invisible md:visible ${
//     previewOpen === true ? 'translate-x-0' : 'translate-x-full'
//   }`}>
//                 {/*content*/}
//                 <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">
//                   {/*header*/}
//                   {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
                  
//                   <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu</> : <><i className="fa-solid fa-binoculars mr-2"/>Preview</>} closeOnClickMethod={() => setPreviewOpen(false)}/>
//                   {/* <div className="fixed top-0 bg-inherit flex items-center z-50 px-2 py-1 h-screen">
//                     test
//                   </div> */}
//                   <br/>
//                   <div className="px-8">
                    
//                   {data && <TalentPreviewCard
//                             lang={lang}
//                             data={data}
//                             tags={selectedLevel1Tags.concat(selectedLevel2Tags)}
//                             // selectedId={
//                             //  selectedTalentId || talentsTable[0].id
//                             // }
//                           />}
//                   </div>

//                   {data.talent_resume_en && <div className={`mx-8 px-6 py-8 mt-10 rounded-xl bg-white py-3 dark:bg-gray-900 shadow-lg flex flex-col h-full text-slate-500 dark:text-slate-300  font-inter overflow-y-auto whitespace-pre-wrap prose-sm max-w-none `}>

//                               {/* <ReactMarkdown> */}
                              
                              
//                             <ReactMarkdownMod args={data.talent_resume_en}/>

//                               {/* </ReactMarkdown> */}
              
//                     </div>}
   
   
//                   {/* <div className="relative p-6 flex-auto text-left">
//                     <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-gray-100">
//                     </div>
//                   </div> */}
                      
                      
//                       </div>
//                       </div></div>
//           </div>

//           {state.talentModalOpen && <ModalOverlay/>}
//         </>

//   );
// };

// export default TalentModal;
